module.exports = __webpack_public_path__ + "components/guide-page/static/icon-wetsuit--boardshorts-8347135c49af5902d0887820e05dcb43.svg";